<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Viloyat" prop="region_id">
                <el-select
                  style="width: 100%"
                  size="large"
                  v-model="form.region_id"
                  @change="getDistricts"
                  :loading="regionsLoading"
                >
                  <el-option
                    v-for="region in regions"
                    :key="region.id"
                    :value="region.id"
                    :label="region.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Tuman" prop="district_id">
                <el-select
                  style="width: 100%"
                  size="large"
                  v-model="form.district_id"
                  :loading="districtsLoading"
                >
                  <el-option
                    v-for="district in districts"
                    :key="district.id"
                    :value="district.id"
                    :label="district.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Ismi Sharifi" prop="fullname">
                <el-input
                  size="large"
                  class="form-input"
                  v-model="form.fullname"
                  type="text"
                />
              </el-form-item>
            </el-col>
            <!-- <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Pinfl" prop="pinfl">
                <el-input
                  :disabled="true"
                  size="large"
                  class="form-input"
                  v-model="form.pinfl"
                  type="number"
                  :placeholder="form.pinfl ? '' : 'mavjud emas'"
                />
              </el-form-item>
            </el-col> -->
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Jinsi" prop="gender" v-if="is_editing">
                <el-select
                  style="width: 100%"
                  size="large"
                  v-model="form.gender"
                >
                  <el-option
                    v-for="gender in genders"
                    :key="gender.id"
                    :value="gender.id"
                    :label="gender.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Holat" v-if="is_editing">
                <el-select
                  style="width: 100%"
                  size="large"
                  v-model="form.status"
                  @change="onStatusChange"
                >
                  <el-option label="Faol"   :value="1" />
                  <el-option label="Nofaol" :value="2" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="showStatusReason">
              <el-form-item label="Sabab (ixtiyoriy)">
                <el-input type="textarea" :rows="2" v-model="form.status_reason" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Kasbi" prop="profession">
                <el-input
                  size="large"
                  class="form-input"
                  v-model="form.profession"
                  type="text"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Telefon raqami" prop="phone_number">
                <el-input
                  size="large"
                  class="form-input"
                  v-model="form.phone_number"
                  type="number"
                  @blur="onPhoneBlur"
                />
              </el-form-item>
              <div class="phone-warning" v-if="phoneCheckWarning">
                Diqqat: bu raqam "{{ phoneCheckWarning.fullname }}" foydalanuvchisiga tegishli.
              </div>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="() => this.$router.go(-1)"
                  >Orqaga</el-button
                >
                <el-button class="custom-btn" type="primary" @click="onSubmit"
                  >Saqlash</el-button
                >
                <el-button
                  v-if="is_editing && form.phone_change_history?.length"
                  class="custom-btn"
                  @click="historyDialog = true"
                  >Tel. tarixi</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>

    <el-dialog v-model="historyDialog" title="Telefon raqami tarixi" width="900px">
      <el-table :data="form.phone_change_history || []" border size="small">
        <el-table-column label="Sana" min-width="140">
          <template #default="scope">{{ $moment(scope.row.changed_at).format("DD-MM-YYYY HH:mm") }}</template>
        </el-table-column>
        <el-table-column prop="old_phone" label="Eski raqam" min-width="140" />
        <el-table-column prop="new_phone" label="Yangi raqam" min-width="140" />
        <el-table-column label="Turi" min-width="140">
          <template #default="scope">
            <el-tag :type="resolutionTagType(scope.row.resolution)" size="small" effect="light">{{ resolutionLabel(scope.row.resolution) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="changed_by_fullname" label="Kim o'zgartirdi" min-width="160" />
        <el-table-column prop="related_user_fullname" label="Bog'liq foydalanuvchi" min-width="160" />
        <el-table-column prop="reason" label="Sabab" min-width="140" />
      </el-table>
    </el-dialog>

    <el-dialog
      v-model="conflictDialog"
      title="Telefon raqami band"
      width="520px"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <p v-if="conflictUser">
        "{{ form.phone_number }}" raqami "{{ conflictUser.fullname }}" ({{ conflictUser.region_title }}, {{ conflictUser.district_title }})
        foydalanuvchisiga tegishli. Davom etish uchun quyidagilardan birini tanlang:
      </p>
      <el-radio-group v-model="phone_conflict_resolution" class="conflict-options">
        <div class="conflict-card">
          <el-radio value="placeholder">Band qilib turgan foydalanuvchiga vaqtinchalik raqam berish (u tizimga kira olmaydi)</el-radio>
        </div>
        <div class="conflict-card">
          <el-radio value="manual_reassign">Band qilib turgan foydalanuvchiga boshqa raqam kiritish</el-radio>
          <el-input
            v-if="phone_conflict_resolution === 'manual_reassign'"
            v-model="conflict_user_new_phone"
            placeholder="Yangi raqam"
            size="large"
            style="margin-top: 8px"
          />
        </div>
        <div class="conflict-card">
          <el-radio value="swap">Foydalanuvchilar raqamini almashtirish</el-radio>
        </div>
        <div class="conflict-card">
          <el-radio value="soft_delete">Band qilib turgan foydalanuvchini o'chirish</el-radio>
        </div>
      </el-radio-group>
      <template #footer>
        <el-button @click="cancelConflict">Bekor qilish</el-button>
        <el-button type="primary" :disabled="!phone_conflict_resolution" @click="confirmResolution">Davom etish</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElNotification, ElMessageBox } from "element-plus";

export default {
  name: "UserForm",
  data() {
    return {
      loading: false,
      is_editing: false,
      originalStatus: null,
      showStatusReason: false,
      regionsLoading: false,
      districtsLoading: false,
      genders: [
        { title: "Erkak", id: "M" },
        { title: "Ayol", id: "F" },
      ],
      regions: [],
      districts: [],
      form: {},
      conflictDialog: false,
      conflictUser: null,
      phone_conflict_resolution: "",
      conflict_user_new_phone: "",
      isResubmitting: false,
      phoneCheckWarning: null,
      historyDialog: false,
      rules: {
        fullname: [
          { required: true, message: "Majburiy maydon", trigger: "blur" },
        ],
        region_id: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
        district_id: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
        profession: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
        phone_number: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    statusLabel(status) {
      const map = { 1: "Faol", 2: "Nofaol", 3: "Bloklangan", 4: "Jarayonda" };
      return map[status] || "-";
    },
    statusTagType(status) {
      const map = { 1: "success", 2: "danger", 3: "danger", 4: "warning" };
      return map[status] || "info";
    },
    onStatusChange(val) {
      this.showStatusReason = val !== this.originalStatus;
    },
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (
            this.form.id &&
            this.originalStatus === 1 &&
            this.form.status !== this.originalStatus
          ) {
            try {
              await ElMessageBox.confirm(
                "Foydalanuvchi holatini o'zgartirish uni tizimdan chiqaradi. Davom etasizmi?",
                "Diqqat!",
                { confirmButtonText: "Ha", cancelButtonText: "Bekor qilish", type: "warning" }
              );
            } catch {
              return;
            }
          }

          this.phone_conflict_resolution = "";
          this.conflict_user_new_phone = "";
          this.isResubmitting = false;
          this.submitUser();
        }
      });
    },
    submitUser() {
      this.loading = true;

      const formData = {
        ...this.form,
        phone_conflict_resolution: this.phone_conflict_resolution,
        conflict_user_new_phone:
          this.phone_conflict_resolution === "manual_reassign"
            ? this.conflict_user_new_phone
            : null,
      };

      this.$http
        .put(`/api/v1/users/${this.form.id}`, formData)
        .then(() => {
          ElNotification({
            title: "Tabriklaymiz",
            message: "Muvafaqiyatli saqlandi",
            type: "success",
          });
          this.$router.go(-1);
        })
        .catch(({ response }) => {
          if (response?.status === 409 && response?.data?.type === "CONFLICT") {
            this.handleConflict(response.data);
            return;
          }
          ElNotification({
            title: "Xatolik",
            message: response?.data?.message || "Iltimos, qayta urinib ko'ring.",
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleConflict(data) {
      if (this.isResubmitting) {
        this.isResubmitting = false;
        ElNotification({
          title: "Xatolik",
          message: data.message || "Bu raqam ham band. Boshqa raqam kiriting.",
          type: "error",
        });
        return;
      }
      this.conflictUser = data.invalid_args;
      this.conflictDialog = true;
    },
    resolutionWarningText(resolution) {
      const name = this.conflictUser?.fullname || "";
      const map = {
        placeholder: `Diqqat! ${name} endi tizimga kira olmaydi. Davom etasizmi?`,
        manual_reassign: `Diqqat! ${name} uchun yangi raqam belgilanadi. Davom etasizmi?`,
        swap: `Diqqat! ${name} bilan telefon raqamlari almashtiriladi. Davom etasizmi?`,
        soft_delete: `Diqqat! ${name} akkaunti o'chiriladi. Davom etasizmi?`,
      };
      return map[resolution] || "Davom etasizmi?";
    },
    async confirmResolution() {
      if (!this.phone_conflict_resolution) return;
      if (
        this.phone_conflict_resolution === "manual_reassign" &&
        !this.conflict_user_new_phone
      ) {
        ElNotification({
          title: "Xatolik",
          message: "Yangi raqamni kiriting",
          type: "warning",
        });
        return;
      }
      try {
        await ElMessageBox.confirm(
          this.resolutionWarningText(this.phone_conflict_resolution),
          "Diqqat!",
          { confirmButtonText: "Ha", cancelButtonText: "Bekor qilish", type: "warning" }
        );
      } catch {
        return;
      }
      this.conflictDialog = false;
      this.isResubmitting = true;
      this.submitUser();
    },
    cancelConflict() {
      this.conflictDialog = false;
      this.phone_conflict_resolution = "";
      this.conflict_user_new_phone = "";
    },
    onPhoneBlur() {
      this.phoneCheckWarning = null;
      if (!this.form.phone_number) return;
      this.$http
        .get("/api/v1/users/check-phone", {
          params: {
            phone_number: this.form.phone_number,
            role: "user",
            exclude_id: this.form.id,
          },
        })
        .then(({ data }) => {
          if (data.exists) this.phoneCheckWarning = data.user;
        })
        .catch(() => {});
    },
    resolutionLabel(r) {
      const map = {
        placeholder: "Vaqtinchalik raqam",
        manual_reassign: "Qo'lda raqam",
        swap: "Almashtirish",
        soft_delete: "O'chirildi",
      };
      return map[r] || r;
    },
    resolutionTagType(r) {
      const map = {
        placeholder: "warning",
        manual_reassign: "primary",
        swap: "info",
        soft_delete: "danger",
      };
      return map[r] || "info";
    },
    getRegions() {
      this.regionsLoading = true;
      this.$http
        .get("/api/v1/regions")
        .then(({ data }) => {
          this.regions = data.regions;
        })
        .catch(() => {})
        .finally(() => {
          this.regionsLoading = false;
        });
    },
    getDistricts() {
      this.districtsLoading = true;
      this.$http
        .get("/api/v1/districts", {
          params: {
            region_id: this.form.region_id,
          },
        })
        .then(({ data }) => {
          this.districts = data.districts;
        })
        .catch(() => {})
        .finally(() => {
          this.districtsLoading = false;
        });
    },
    getSingleUser(id) {
      this.loading = true;
      this.$http
        .get(`/api/v1/users/${id}`)
        .then(({ data }) => {
          this.form = data;
          this.originalStatus = data.status;
          this.getDistrict(this.form.district_id);
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDistrict(id) {
      this.loading = true;
      this.$http
        .get(`/api/v1/districts/${id}`)
        .then(({ data }) => {
          this.districts.push(data);
          this.form.region_id = data.region_id;
          this.getDistricts();
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.$store.commit(
      "updateHeaderTitle",
      this.$route.query.from === "monitoring"
        ? "Monitoring foydalanuvchini tahrirlash"
        : "Foydalanuvchini tahrirlash"
    );
    if (this.$route.params.id) {
      this.is_editing = true;
      this.getSingleUser(this.$route.params.id);
    }
    this.getRegions();
  },
};
</script>

<style scoped>
.conflict-options {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  width: 100%;
}
.conflict-card {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  padding: 10px 12px;
}
.conflict-card :deep(.el-radio) {
  width: 100%;
  height: auto;
  white-space: normal;
  align-items: flex-start;
}
.conflict-card :deep(.el-radio__label) {
  white-space: normal;
  line-height: 1.4;
}
.phone-warning {
  color: #e6a23c;
  font-size: 12px;
  margin-top: -14px;
  margin-bottom: 8px;
}
</style>
